// extracted by mini-css-extract-plugin
export default {"personboost_container":"R-","personboost_content":"S-","personboost_title":"T-","personboost_text":"U-","toleft":"V-","personboost_tiles_container":"W-","personalized_tiles_container":"X-"};
    if(module.hot) {
      // 1711717535223
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  